import {
  getIsFraudDetectionInPath,
  getIsNextNodeS2SProvider,
} from "../components/nodes/TriggerNode/utils";
import { RoutingGraph } from "../services";
import { TriggerNode } from "../types/nodes";
import { AvailableCondition } from "../types/routingData";

export function isTriggerS2S(options: {
  availableConditions: AvailableCondition[] | null;
  trigger: TriggerNode;
  routingGraph: RoutingGraph;
}) {
  const { availableConditions, trigger, routingGraph } = options;

  const appliedConditions = trigger.data.appliedConditions ?? {};

  const appliedConditionsEntries = Object.entries(appliedConditions ?? {});
  const hasS2SCondition = appliedConditionsEntries.some(
    ([_conditionId, condition]) => {
      if (!availableConditions) return false;

      const conditionData = availableConditions.find(
        (availableCondition) =>
          availableCondition.resourceType === condition.resourceType
      );

      return Boolean(conditionData?.s2s);
    }
  );
  if (hasS2SCondition) return true;

  const isStoredCardInfoOrNetworkToken = appliedConditionsEntries.some(
    ([_conditionId, condition]) => {
      return (
        condition.resourceType === "tokenPresent" &&
        (condition?.data?.value === "STORED_CARD_INFO" ||
          condition?.data?.value === "NETWORK_TOKEN")
      );
    }
  );
  if (isStoredCardInfoOrNetworkToken) return true;

  const hasFraudProvider = getIsFraudDetectionInPath({
    node: trigger,
    routingGraph,
  });
  if (hasFraudProvider) return true;

  const isNextNodeS2SProvider = getIsNextNodeS2SProvider({
    trigger,
    routingGraph,
  });

  if (isNextNodeS2SProvider) return true;
  return false;
}
